export const H03_SUBTITLE = 'This may be a single-family home, townhouse or duplex you own and live in.';
export const H06_SUBTITLE = 'This is likely a multi-family building or complex in which you own a unit.';
export const HOME_FORM_TITLE = 'Enter the home details';
export const HOME_LABEL_NAME = 'Home Info';
export const H05_SUBTITLE = 'The HO5 is an open perlis insurance policy coverage for a single-family home or duplex.';
export const DP1_SUBTITLE = 'This is a property you own that may be vacant or under major renovation.';
export const DP3_SUBTITLE = 'This may be a single-family home, townhouse or duplex you own and rent out.';
export const HO4_SUBTITLE = `Renter's insurance (HO4) for covering Renter's personal property and liability`;
